import { render, staticRenderFns } from "./Sla.vue?vue&type=template&id=ba6cd174&scoped=true"
import script from "./Sla.vue?vue&type=script&lang=js"
export * from "./Sla.vue?vue&type=script&lang=js"
import style0 from "./Sla.vue?vue&type=style&index=0&id=ba6cd174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6cd174",
  null
  
)

export default component.exports